import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { clearFiltersIfEmpty, selectAvailability } from '../store/actions/query';
import { delayRetrieveRecords } from '../store/actions/search';
import ResearchFilters from './research_filters';

export class ResearchFiltersContainer extends React.Component {
  static propTypes = {
    availabilities: PropTypes.array.isRequired,
    clearFiltersIfEmpty: PropTypes.func.isRequired,
    delayRetrieveRecords: PropTypes.func.isRequired,
    multifamilyFilter: PropTypes.object.isRequired,
    propertyFilter: PropTypes.object.isRequired,
    selectedAssetClasses: PropTypes.array.isRequired,
    selectedAvailabilities: PropTypes.array.isRequired,
    selectedBuildingClasses: PropTypes.array.isRequired,

    onAvailabilityChange: PropTypes.func.isRequired,
  }

  handleRetrieveRecords = () => {
    const { clearFiltersIfEmpty, delayRetrieveRecords } = this.props;
    clearFiltersIfEmpty();
    delayRetrieveRecords();
  };

  handleAvailabilityChange = (e) => {
    const { onAvailabilityChange } = this.props;
    onAvailabilityChange(e.target.value, e.target.checked);
    this.handleRetrieveRecords();
  };

  render() {
    return (
      <ResearchFilters
        {...this.props}
        onAvailabilityChange={this.handleAvailabilityChange}
      />
    );
  }
}

const mapStateToProps = state => ({
  availabilities: state.static.availabilities,
  multifamilyFilter: state.query.multifamilyFilter,
  propertyFilter: state.query.propertyFilter,
  selectedBuildingClasses: state.query.buildingClasses,
  selectedAvailabilities: state.query.availabilities,
  selectedAssetClasses: state.query.assetClasses,
  selectedInvestmentTypes: state.query.investmentTypes
});

const mapDispatchToProps = {
  clearFiltersIfEmpty,
  delayRetrieveRecords,

  onAvailabilityChange: selectAvailability,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResearchFiltersContainer);
